export type TituloTelaCheia = string | ((tituloAcao?: string) => string);

export const tituloDrawerTelaCheia = (titulo?: TituloTelaCheia, tituloAcao?: string): string | undefined =>
  typeof titulo === "function" ? titulo(tituloAcao) : titulo;

export default tituloDrawerTelaCheia;
